import { createSelector } from 'reselect';
import { getSortedUserActivity } from '../../redux-jigsaw/userdata/selectors';
import { hasHighlights } from 'app/api/redux-jigsaw/userdata/highlights/selectors';
import { hasNotes } from 'app/api/redux-jigsaw/userdata/notes/selectors';
import { hasBookmarks } from 'app/api/redux-jigsaw/userdata/bookmarks/selectors';

export function isPanelOpen(state) {
  return state.ui.middle.isPanelOpen;
}

export function isSearchOpen(state) {
  return state.ui.middle.isSearchOpen;
}

export function isReadAloudOpen(state) {
  return state.ui.middle.isReadAloudOpen;
}

export function isNotesFilterOn(state) {
  return state.ui.middle.notesFilterOn;
}

export function isHighlightsFilterOn(state) {
  return state.ui.middle.highlightsFilterOn;
}

export function isBookmarksFilterOn(state) {
  return state.ui.middle.bookmarksFilterOn;
}

export function hasUserActivity(state) {
  return getSortedUserActivity(state).length > 0;
}

export const hasFilteredUserActivity = createSelector(
  state => isNotesFilterOn(state),
  state => isHighlightsFilterOn(state),
  state => isBookmarksFilterOn(state),
  state => hasNotes(state),
  state => hasHighlights(state),
  state => hasBookmarks(state),
  (
    notesOn,
    highlightsOn,
    bookmarksOn,
    hasNotes,
    hasHighlights,
    hasBookmarks
  ) => {
    return (
      (notesOn && hasNotes) ||
      (bookmarksOn && hasBookmarks) ||
      (highlightsOn && hasHighlights)
    );
  }
);

export const getFilteredActivityItems = createSelector(
  state => isNotesFilterOn(state),
  state => isHighlightsFilterOn(state),
  state => isBookmarksFilterOn(state),
  state => getSortedUserActivity(state),
  (notes, highlights, bookmarks, data) => {
    return data.filter(
      d =>
        (notes && d.type === 'note') ||
        (highlights && d.type === 'highlight') ||
        (bookmarks && d.type === 'bookmark')
    );
  }
);
